<template lang="html">
  <div id="floorplan-detail" class="w-60">
    <!-- Actionbar -->
    <floorplan-detail-actions :pdf="plan.current.images.pdf" />

    <!-- Index info -->
    <div class="pt2 tc f7 i center moon-gray">
      {{ indexDetail }}
    </div>

    <!-- Heading -->
    <floorplan-detail-heading :plan="plan" />

    <!-- Details -->
    <floorplan-detail-specs :plan="plan.current" />

    <!-- Floor plan image -->
    <div class="fp-image tc mv4" :class="{'loaded': loaded}">
      <img class="ph4" :src="planFpImg" />
    </div>

    <!-- Floor plan keyplate -->
    <div class="kp-image">
      <img :src="planKpImg" />
    </div>

    <!-- Panoramic image -->
    <floorplan-panoramic-view :plan="plan.current" :view="planView" v-if="planView" />

    <!--<back-to-top></back-to-top>-->
    <div class="sticky bottom-0 w-100 z-999 pb4 pt3 bot-btns" v-if="planView">
      <div class="flex justify-center">
        <v-btn @click.native="scrollToTop()"
          :label="'FLOORPLAN'"
          class="bg-black raise b white mr2"
        />
        <v-btn @click.native="scrollToBottom()"
          :label="'VIEW'"
          class="bg-black raise b white"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BackToTopComponent from '@/components/BackToTop';
import ButtonComponent from '@/components/Button';
import FloorplanMixin from '../FloorplanMixin';
import FloorplanDetailActionsComponent from './FloorplanDetailActions';
import FloorplanDetailHeadingComponent from './FloorplanDetailHeading';
import FloorplanDetailSpecsComponent from './FloorplanDetailSpecs';
import FloorplanPanoramicViewComponent from './FloorplanPanoramicView';


export default {
  name: 'floorplan-detail',
  components: {
    'v-btn': ButtonComponent,
    'floorplan-detail-actions': FloorplanDetailActionsComponent,
    'floorplan-detail-heading': FloorplanDetailHeadingComponent,
    'floorplan-detail-specs': FloorplanDetailSpecsComponent,
    'floorplan-panoramic-view': FloorplanPanoramicViewComponent,
    'back-to-top': BackToTopComponent
  },
  mixins: [FloorplanMixin],
  data() {
    return {
      planImg: null,
      loaded: false
    };
  },
  computed: {
    ...mapGetters({
      getPlan: 'getFloorplanById',
      activeFloorplans: 'activeFloorplans',
      favouritesMode: 'favouritesMode',
      favourites: 'favourites',
      projectId: 'adhocId',
      views: 'getViews'
    }),
    highestFloor() {
      return Math.max(...this.plan.current.stacks[0].suites.map(suite => suite.floor));
    },
    indexDetail() {
      const plans = (this.favouritesMode) ? this.favourites : this.activeFloorplans;
      const index = this.activeFloorplans.findIndex(fp => fp.id === this.$route.params.id) + 1;
      let retString = `viewing floorplan ${index} of ${plans.length} filtered floorplans`;
      if (this.favouritesMode) retString = `viewing floorplan ${index} of ${plans.length} favourited floorplans`;
      return retString;
    },
    plan() {
      return this.getPlan(this.$route.params.id);
    },
    planFpImg() {
      this.SET_KEYPLATE(this.baseUrl + this.plan.current.images.kp.url);
      return this.baseUrl + this.plan.current.images.fp.url;
    },
    planKpImg() {
      return this.baseUrl + this.plan.current.images.kp.url;
    },
    planView() {
      const viewCombos = {
        3: { min: 1, max: 4 },
        6: { min: 5, max: 7 },
        9: { min: 8, max: 10 },
        11: { min: 11, max: 12 }
      };

      const dir = this.plan.current.exposure.join('');
      let matchingFloor = 0;
      Object.keys(viewCombos).forEach((floor) => {
        if (this.highestFloor >= viewCombos[floor].min && this.highestFloor <= viewCombos[floor].max) {
          matchingFloor = parseInt(floor, 10);
        }
      });
      return this.views.find(view => view.floor === matchingFloor && dir.toLowerCase() === view.dir);
    }
  },
  methods: {
    ...mapActions({
      SET_KEYPLATE: 'SET_KEYPLATE'
    }),
    scrollToTop() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },
    scrollToBottom() {
      window.scroll({
        top: 9999,
        left: 0,
        behavior: 'smooth'
      });
    }
  },
  created() {
    this.planImg = new Image();
    this.planImg.onload = () => {
      setTimeout(() => {
        this.loaded = true;
      }, 250, this);
    };
    this.planImg.src = this.baseUrl + this.plan.current.images.fp.url;
  },
  watch: {
    planFpImg() {
      this.loaded = false;
      this.planImg.src = this.baseUrl + this.plan.current.images.fp.url;
    }
  }
};
</script>

<style lang="scss">
#floorplan-detail {

  @media (max-width: 767px) {
    width: 100%;
  }

  @media screen and (max-width: $breakpoint-medium) {
    padding-top: 0;
  }

  @media screen and (min-width: $breakpoint-medium) {
    // padding-top: 60px;
    padding-bottom: 0;
  }

  i.material-icons, span {
    vertical-align: middle;
  }

  .fp-image {
    opacity: 0;
    transition: opacity 0s ease-out;
    min-height: 500px;
    &.loaded {
      min-height: initial;
      opacity: 1;
      transition: opacity 0.25s ease-out;
    }
  }

  .fp-image img {
    max-width: 100%;
    max-height: 80vh;
  }

  .bot-btns {
    @media screen and (max-width: $breakpoint-medium) {
      padding-bottom: 0;
      bottom: 4rem;
    }
  }

  .kp-image {
    display: none;
    @media (max-width: 767px) {
      display: block;
      img {
        max-width: 50%;
        width: auto;
      }
      margin-bottom: 4rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/FloorplansPage/FloorplanDetail/FloorplanDetail.vue